// Shared types for the "Meters in documenten" settings tab.
// Mirrors the backend DocumentMeterSettings entity.

export type MeterFieldSource =
  | { kind: "fieldValue"; key: string } // asset.fieldValues[key]
  | { kind: "assetProp"; key: string } // asset[key], e.g. location / name
  | { kind: "latestReadingValue" } // laatste meterstand (waarde)
  | { kind: "latestReadingDate" } // laatste meterstand (datum)
  | { kind: "role" } // nutsvoorziening-label (Elektriciteit/Gas/Water)
  | { kind: "origin" }; // Privatieve / Gemeenschappelijke meter

export interface MeterFieldMapping {
  documentField: string;
  source: MeterFieldSource;
}

export interface MeterRole {
  key: string;
  label: string;
  assetTypeIds: number[];
}

export interface MeterScope {
  includeUnit: boolean;
  includeBuilding: boolean;
  unitOriginLabel: string;
  buildingOriginLabel: string;
}

export interface DocumentMeterSettings {
  roles: MeterRole[];
  fieldMappings: MeterFieldMapping[];
  scope: MeterScope;
}

export interface AssetTypeOption {
  id: number;
  name: string;
}

export interface FieldDefinitionOption {
  fieldName: string;
  displayName: string;
}

// ─── Source encode/decode for use as <Select> string values ──────────────

export const encodeSource = (source: MeterFieldSource): string => {
  switch (source.kind) {
    case "fieldValue":
      return `fieldValue:${source.key}`;
    case "assetProp":
      return `assetProp:${source.key}`;
    default:
      return source.kind;
  }
};

export const decodeSource = (value: string): MeterFieldSource => {
  if (value.startsWith("fieldValue:")) {
    return { kind: "fieldValue", key: value.slice("fieldValue:".length) };
  }
  if (value.startsWith("assetProp:")) {
    return { kind: "assetProp", key: value.slice("assetProp:".length) };
  }
  return { kind: value as MeterFieldSource["kind"] } as MeterFieldSource;
};

// Special (non field-value) sources shown in the bron-dropdown.
export const SPECIAL_SOURCE_OPTIONS: { value: string; label: string }[] = [
  { value: "role", label: "Nutsvoorziening (Elektriciteit/Gas/Water)" },
  { value: "origin", label: "Privatief / Gemeenschappelijk" },
  { value: "assetProp:location", label: "Locatie (voorziening)" },
  { value: "assetProp:name", label: "Naam (voorziening)" },
  { value: "latestReadingValue", label: "Laatste meterstand (waarde)" },
  { value: "latestReadingDate", label: "Laatste meterstand (datum)" },
];
